// extracted by mini-css-extract-plugin
module.exports = {"value":"expand-field_value__2HM-h","spacer":"expand-field_spacer__1zxJV","more":"expand-field_more__1HGuF","less":"expand-field_less__29VS-","link":"expand-field_link__Kv983"};